import gql from "graphql-tag";

const RUNNER_SHIFT_STATUS_FIELDS = gql`
  fragment RunnerShiftStatusFields on RunnerShiftStatus {
    id
    shiftId
    shiftDate
    startedAt
    endedAt
    status
    shift {
      id
      name
      startTime
      endTime
    }
  }
`;

export const myRunnerShiftStatusQuery = gql`
  query MyRunnerShiftStatus {
    myRunnerShiftStatus {
      ...RunnerShiftStatusFields
    }
  }
  ${RUNNER_SHIFT_STATUS_FIELDS}
`;

export const startRunnerShiftMutation = gql`
  mutation StartRunnerShift {
    startRunnerShift {
      ...RunnerShiftStatusFields
    }
  }
  ${RUNNER_SHIFT_STATUS_FIELDS}
`;

export const endRunnerShiftMutation = gql`
  mutation EndRunnerShift {
    endRunnerShift {
      ...RunnerShiftStatusFields
    }
  }
  ${RUNNER_SHIFT_STATUS_FIELDS}
`;
